import { Grid } from '@mui/material';
import { ScreenConfiguration } from 'src/components/screenConfiguration';
import { InfoBox } from 'src/features/components/editComponentPage/modules/InfoBox';
import { useGetAllLayoutType } from 'src/hooks';
import { ILayoutType } from 'src/interfaces';
import { lang } from 'src/utils';

import { locationTimingsHeaderProps } from './LocationGroupTimingsHeader.interface';
import {
  AlertContainer,
  Container,
  Divider,
  SubHeader,
  SubHeaderText,
} from './LocationGroupTimingsHeader.styled';

export const LocationGroupTimingsHeader = (
  props: locationTimingsHeaderProps,
) => {
  const { data: layoutTypes, isLoading: isLoadingLayouts } =
    useGetAllLayoutType();

  return (
    <Container>
      <Grid container spacing={2}>
        <Grid item xs={12} md={7}>
          <Grid container spacing={6}>
            <Grid item>
              <SubHeader>{lang.screenConfiguration}</SubHeader>
              {props.locationGroupData?.channel_name && (
                <ScreenConfiguration
                  channelName={props.locationGroupData?.channel_name}
                  scale={0.03}
                />
              )}
            </Grid>
            <Grid item>
              <SubHeader>{props.locationGroupData?.channel_name}</SubHeader>
              {!isLoadingLayouts && layoutTypes && (
                <SubHeaderText>
                  {
                    layoutTypes.find(
                      (layout: ILayoutType) =>
                        layout.id === props.locationGroupData?.layout_type_id,
                    )?.name
                  }
                </SubHeaderText>
              )}
            </Grid>
            <Grid item>
              <SubHeader>{'# of locations in group'}</SubHeader>
              <SubHeaderText>{Number(props.locationsCount)}</SubHeaderText>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={5}>
          <AlertContainer>
            <InfoBox visible>
              {!props.rbStoreIntegration
                ? lang.locationGroupTimingsAlert
                : lang.alertMessages.locationGoupRFM}
            </InfoBox>
          </AlertContainer>
        </Grid>
      </Grid>
      <Divider />
    </Container>
  );
};
